import React from "react";
import {
  Container,
  ContainerInner,
  ContainerColor,
  ContainerText,
  Title,
  ButtonCard,
  SwooshSVG,
  LocationWrapper,
  LocationNameWrapper,
  ImageBadgeCity,
} from "./CardKota.styled";
import Chip from "../Chip";
import { func } from "../../../utils";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import analytics from "../../../utils/analytics";
import useWindowSize from "../../../hooks/useWindowSize";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const CardKota = ({ data = {}, isLoading = false, cardWidth }) => {
  const navigate = useNavigate();
  const { size } = useWindowSize();

  const isMobileView = (size?.width || 0) <= 768;

  const {
    region_name,
    event_start_date,
    event_end_date,
    event_location,
    video_url,
    registration_url,
    is_registration_open,
    key_visual,
    key_visual_mobile,
    registration_end_date,
  } = data;

  const startDate = moment(event_start_date);
  const endDate = moment(event_end_date);
  const regEndDate = moment(registration_end_date);

  const isSameMonthEvent = startDate.format("MMMM") === endDate.format("MMMM");
  const cardDate = isSameMonthEvent
    ? `${startDate?.format("D")} - ${endDate?.format("D MMMM")}`
    : `${startDate?.format("D MMMM")} - ${endDate?.format("D MMMM")}`;

  const viewData = React.useMemo(() => {
    const currentDate = moment();

    /* Karena moment itunganya kalo udah di bawah 24 jam itu di anggep 0, maka perlu di tambah 1 */
    const diffHours = startDate?.diff(currentDate, "hours");
    const diffDays = startDate?.diff(currentDate, "days");
    const differentDays = diffHours <= 0 ? diffDays : diffDays + 1;

    /* Before event & > 30 Hari or 31 Hari */
    if (differentDays > 30 || differentDays > 31) {
      if (!is_registration_open) {
        return {
          badge: "AKAN DATANG",
          badgeBackgroundColor: "#6A7481",
          buttonText: "Akan Datang",
          buttonDisabled: true,
          buttonBgColor: "transparent",
          buttonBorderColor: "#6A7481",
          buttonTextColor: "#6A7481",
          grayScale: true,
          onClick: () => {},
        };
      }
    }

    /* Before Event & 1 - 30 hari or 31 hari */
    if (differentDays >= 1 && (differentDays <= 30 || differentDays <= 31)) {
      // Registration Status = Yes
      if (is_registration_open) {
        return {
          badge: `${differentDays} Hari Lagi`,
          badgeBackgroundColor: "#00BCF1",
          buttonText: "Registrasi",
          buttonDisabled: false,
          buttonBgColor: "#00BCF1",
          buttonBorderColor: "#00BCF1",
          buttonTextColor: "#fff",
          grayScale: false,
          onClick: () => {
            if (!registration_url) {
              return navigate(
                `/${String(data?.region_name)?.toLowerCase()}/registrasi`,
                {
                  state: {
                    city: String(data?.region_name)?.toLowerCase(),
                  },
                }
              );
            }
            return window.open(registration_url, "_blank");
          },
        };
      }

      // Registration Status = No
      if (!is_registration_open) {
        return {
          badge: `${differentDays} Hari Lagi`,
          badgeBackgroundColor: "#00BCF1",
          buttonText: "Lihat Detail",
          buttonDisabled: false,
          buttonBgColor: "#fff",
          buttonBorderColor: "#00BCF1",
          buttonTextColor: "#00BCF1",
          grayScale: false,
          onClick: () => {
            return navigate(`/${String(region_name).toLowerCase()}`);
          },
        };
      }
    }

    // Event Day
    if (differentDays === 0) {
      /* Have Video URL */
      if (!!video_url) {
        return {
          badge: "LIVE",
          badgeBackgroundColor: "#FF110D",
          buttonText: "Tonton Live",
          buttonDisabled: false,
          buttonBgColor: "#00BCF1",
          buttonBorderColor: "transparent",
          buttonTextColor: "#fff",
          grayScale: false,
          onClick: () => {
            return window.open(video_url, "_blank");
          },
        };
      }

      if (!video_url) {
        return {
          badge: "Berlangsung",
          badgeBackgroundColor: "#1F2D3D",
          buttonText: "Lihat Detail",
          buttonDisabled: false,
          buttonBgColor: "#fff",
          buttonBorderColor: "#00BCF1",
          buttonTextColor: "#00BCF1",
          grayScale: false,
          onClick: () => {
            return navigate(`/${String(region_name).toLowerCase()}`);
          },
        };
      }
    }

    // Range Date
    if (
      currentDate?.isSameOrAfter(startDate, "day") &&
      currentDate?.isSameOrBefore(endDate, "day")
    ) {
      if (!video_url) {
        return {
          badge: "Berlangsung",
          badgeBackgroundColor: "#1F2D3D",
          buttonText: "Lihat Detail",
          buttonDisabled: false,
          buttonBgColor: "#fff",
          buttonBorderColor: "#00BCF1",
          buttonTextColor: "#00BCF1",
          grayScale: false,
          onClick: () => {
            return navigate(`/${String(region_name).toLowerCase()}`);
          },
        };
      }

      /* Have Video URL */
      if (!!video_url) {
        return {
          badge: "LIVE",
          badgeBackgroundColor: "#FF110D",
          buttonText: "Tonton Live",
          buttonDisabled: false,
          buttonBgColor: "#00BCF1",
          buttonBorderColor: "transparent",
          buttonTextColor: "#fff",
          grayScale: false,
          onClick: () => {
            return window.open(video_url, "_blank");
          },
        };
      }
    }

    // Post Event
    if (currentDate?.isAfter(endDate, "day")) {
      return {
        badge: "Udah Lewat",
        badgeBackgroundColor: "rgba(31, 45, 61, 0.70)",
        buttonText: "Lihat Detail",
        buttonDisabled: false,
        buttonBgColor: "transparent",
        buttonBorderColor: "#1F2D3D",
        buttonTextColor: "#1F2D3D",
        grayScale: false,
        onClick: () => {
          analytics.sendEvent({
            event: "pialabyu_lihatDetail",
            city: region_name,
          });
          return navigate(`/${String(region_name).toLowerCase()}`);
        },
      };
    }
  }, [registration_url, video_url, is_registration_open]);

  const _renderView = () => {
    const isActive = !(
      (!registration_url && !is_registration_open) ||
      (!is_registration_open && !registration_url)
    );

    const handleCardClick = () =>
      navigate(`/${String(region_name).toLowerCase()}`);

    return (
      <Container
        img={"https://event_locationhold.co/157x217"}
        onClick={
          viewData?.badge === "AKAN DATANG" ? undefined : handleCardClick
        }
        cardWidth={cardWidth}
        isActive={isActive}
      >
        <ContainerColor cardWidth={cardWidth}>
          <Chip
            text={viewData?.badge?.toUpperCase()}
            backgroundColor={viewData?.badgeBackgroundColor}
            color={"#fff"}
          />
          <SwooshSVG
            src={func.getStaticImg(
              isMobileView ? "/bg/swosh-abstrac.svg" : "/bg/swosh-abstrac_d.svg"
            )}
          />
          <ContainerInner>
            {isMobileView ? (
              <>
                <ContainerText>
                  <ImageBadgeCity
                    grayScale={viewData?.grayScale}
                    src={imgPath + key_visual_mobile}
                  />
                  <Title
                    fontSize={isMobileView ? "18px" : "20px"}
                    lineHeight={"24px"}
                  >
                    {String(region_name)?.toUpperCase()}
                  </Title>
                  <Title>{cardDate}</Title>
                  <LocationWrapper>
                    <img
                      src={func.getStaticImg(`/illustration/pin location.svg`)}
                    />
                    <LocationNameWrapper>
                      <Title color={"#6A7481"} fontWeight={"400"}>
                        {event_location}
                      </Title>
                    </LocationNameWrapper>
                  </LocationWrapper>
                </ContainerText>
                <ButtonCard
                  disabled={viewData?.buttonDisabled}
                  color={viewData?.buttonTextColor}
                  backgroundColor={viewData?.buttonBgColor}
                  borderColor={viewData?.buttonBorderColor}
                  onClick={(event) => {
                    event.stopPropagation();
                    viewData?.onClick();
                  }}
                >
                  {viewData?.buttonText}
                </ButtonCard>
              </>
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    width: `${
                      Number(String(cardWidth)?.replace("px", "")) - 40
                    }px`,
                    justifyContent: "space-between",
                    marginTop: "12px",
                  }}
                >
                  <ContainerText>
                    <Title
                      fontSize={isMobileView ? "18px" : "20px"}
                      lineHeight={"24px"}
                    >
                      {String(region_name)?.toUpperCase()}
                    </Title>
                    <Title>{cardDate}</Title>
                    <LocationWrapper>
                      <img
                        src={func.getStaticImg(
                          `/illustration/pin location.svg`
                        )}
                      />
                      <LocationNameWrapper>
                        <Title color={"#6A7481"} fontWeight={"400"}>
                          {event_location}
                        </Title>
                      </LocationNameWrapper>
                    </LocationWrapper>
                  </ContainerText>
                  <ImageBadgeCity
                    grayScale={viewData?.grayScale}
                    src={imgPath + key_visual}
                  />
                </div>
                <ButtonCard
                  disabled={viewData?.buttonDisabled}
                  color={viewData?.buttonTextColor}
                  backgroundColor={viewData?.buttonBgColor}
                  borderColor={viewData?.buttonBorderColor}
                  onClick={(event) => {
                    event.stopPropagation();
                    viewData?.onClick();
                  }}
                >
                  {viewData?.buttonText}
                </ButtonCard>
              </>
            )}
          </ContainerInner>
        </ContainerColor>
      </Container>
    );
  };

  if (isLoading) return null;

  return <>{_renderView()}</>;
};

export default CardKota;
